import React, { useCallback } from 'react';

import { audioManager } from 'lib/audio/audio-manager';
import { AUDIO_TYPES } from 'lib/audio/audio.types';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  onClick: () => void;
  className?: string;
}

const BetButton = ({ text, onClick, className, ...rest }: Props) => {
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      audioManager.playSound(AUDIO_TYPES.CLICK);
      onClick();
    },
    [onClick],
  );

  return (
    <button
      className={`${className ?? ''} ${
        rest.disabled ? 'border-gray-border text-gray-border' : 'border-white text-white'
      } rounded-[7px] border px-2.5 py-1.5 focus:outline-none sm:px-5 sm:pb-2.5 sm:pt-[14px]`}
      onClick={handleClick}
      {...rest}
    >
      <span className="whitespace-nowrap text-[11px] font-medium leading-5 sm:text-[21px]">
        {text}
      </span>
    </button>
  );
};

export default BetButton;
